import React from 'react';
import { debugContextDevtool } from 'react-context-devtool';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/main.scss';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

debugContextDevtool(container, {
  disable: process.env.NODE_ENV === 'production',
});
